export const formatPhone = (phone) => {
    if (phone) {
        let match = phone.toString().match(/^(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})$/);
        if (match) {
            return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`
        }
    }
}

export const errorConverterFields = (action) => {
    const errors = JSON.parse(action.error.message).fieldErrors;
    const res = {};
    errors.forEach(err => res[err.fieldName] = err.message);
    return res;
}

export const errorConverter = (action) => {
    try {
        return JSON.parse(action.error.message).message
    } catch (err) {
        return action.error.message;
    }
}